export const DEFAULT_LANGUAGE = 'en';
export const SUPPORTED_LANGUAGES = ['en', 'fr'] as const;
export type SupportedLanguage = typeof SUPPORTED_LANGUAGES[number];

// Professional roles for mentor application form
export const PROFESSIONAL_ROLES = [
  'CEO',
  'Chief Executive Officer',
  'Chief Operating Officer (COO)',
  'Chief Financial Officer (CFO)',
  'Chief Marketing Officer (CMO)',
  'Chief Technology Officer (CTO)',
  'Managing Director',
  'Executive Director',
  'Founder',
  'Co-Founder',
  'Entrepreneur',
  'Startup Founder',
  'Business Owner',
  'President',
  'Vice President',
  'Director',
  'General Manager',
  'Operations Manager',
  'Program Manager',
  'Project Manager',
  'Product Manager',
  'Business Development Manager',
  'Sales Manager',
  'Marketing Manager',
  'Digital Marketing Manager',
  'Human Resources Manager',
  'Finance Manager',
  'NGO Leader',
  'Non-Profit Director',
  'Community Leader',
  'Social Impact Leader',
  'Women Empowerment Advocate',
  'Gender Equality Specialist',
  'Development Consultant',
  'International Development Specialist',
  'Policy Advisor',
  'Government Official',
  'Diplomat',
  'Ambassador',
  'Board Member',
  'Chairperson',
  'Team Lead',
  'Senior Consultant',
  'Business Consultant',
  'Strategy Consultant',
  'Management Consultant',
  'Leadership Coach',
  'Executive Coach',
  'Business Coach',
  'Mentor',
  'Advisor',
  'Investor',
  'Angel Investor',
  'Venture Capitalist',
  'Financial Analyst',
  'Investment Banker',
  'Accountant',
  'Lawyer',
  'Legal Counsel',
  'Academic Researcher',
  'Professor',
  'University Lecturer',
  'Education Consultant',
  'Training Specialist',
  'Public Speaker',
  'Author',
  'Writer',
  'Journalist',
  'Media Personality',
  'Communications Specialist',
  'Public Relations Manager',
  'Brand Manager',
  'Content Creator',
  'Influencer',
  'Software Engineer',
  'Tech Lead',
  'Data Scientist',
  'UX Designer',
  'Architect',
  'Healthcare Professional',
  'Doctor',
  'Nurse',
  'Psychologist',
  'Social Worker',
  'Teacher',
  'Principal',
  'Engineer',
  'Scientist',
  'Researcher',
  'Artist',
  'Designer',
  'Photographer',
  'Filmmaker',
  'Event Planner',
  'Hospitality Manager',
  'Tourism Specialist',
  'Agriculture Specialist',
  'Environmental Specialist',
  'Sustainability Expert',
  'Other'
].sort();

// Areas of interest for mentor application form
export const AREAS_OF_INTEREST = [
  'Leadership Development',
  'Women Empowerment',
  'Gender Equality',
  'Executive Leadership',
  'Team Management',
  'Strategic Planning',
  'Organizational Development',
  'Change Management',
  'Crisis Management',
  'Decision Making',
  'Public Speaking',
  'Communication Skills',
  'Negotiation Skills',
  'Conflict Resolution',
  'Emotional Intelligence',
  'Personal Branding',
  'Professional Development',
  'Career Advancement',
  'Mentorship & Coaching',
  'Talent Development',
  'Succession Planning',
  'Entrepreneurship',
  'Business Development',
  'Startup Building',
  'Innovation Management',
  'Product Development',
  'Market Strategy',
  'Business Planning',
  'Financial Management',
  'Investment & Funding',
  'Grant Writing',
  'Fundraising',
  'Non-Profit Management',
  'NGO Operations',
  'Community Development',
  'Social Impact',
  'Social Entrepreneurship',
  'Sustainable Development',
  'Corporate Social Responsibility',
  'International Development',
  'Policy Development',
  'Advocacy & Campaigning',
  'Government Relations',
  'Diplomatic Relations',
  'Cross-Cultural Communication',
  'Diversity & Inclusion',
  'Human Rights',
  'Education & Training',
  'Capacity Building',
  'Skills Development',
  'Youth Development',
  'Adult Education',
  'Digital Marketing',
  'Social Media Strategy',
  'Content Marketing',
  'Brand Management',
  'Public Relations',
  'Media Relations',
  'Customer Relations',
  'Stakeholder Management',
  'Partnership Development',
  'Network Building',
  'Event Management',
  'Project Management',
  'Program Management',
  'Operations Management',
  'Supply Chain Management',
  'Quality Management',
  'Risk Management',
  'Compliance Management',
  'Human Resources',
  'Recruitment & Selection',
  'Performance Management',
  'Employee Engagement',
  'Organizational Culture',
  'Sales & Business Development',
  'Customer Acquisition',
  'Market Research',
  'Competitive Analysis',
  'International Business',
  'Export & Import',
  'Agriculture & Food Security',
  'Healthcare Management',
  'Education Management',
  'Environmental Conservation',
  'Climate Change',
  'Renewable Energy',
  'Technology Adoption',
  'Digital Transformation',
  'E-commerce',
  'Financial Technology',
  'Mobile Banking',
  'Microfinance',
  'Economic Development',
  'Rural Development',
  'Urban Planning',
  'Infrastructure Development',
  'Tourism Development',
  'Cultural Preservation',
  'Arts & Creative Industries',
  'Media & Communications',
  'Journalism & Writing',
  'Research & Analysis',
  'Data Analysis',
  'Legal Affairs',
  'Intellectual Property',
  'Ethics & Governance',
  'Board Governance',
  'Corporate Governance',
  'Transparency & Accountability',
  'Other'
].sort();